import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=0de6e1c2&"
import script from "./OrderInfo.vue?vue&type=script&lang=babel&"
export * from "./OrderInfo.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports